import React, { Fragment, useState } from "react";
import moment from "moment";
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem, Dropdown, Card, Modal, ModalHeader, ModalFooter, ModalBody, Button } from "reactstrap";
import { Colxx } from "../../../../../../components/common/CustomBootstrap";


const toDoList=({ item, handleSubmit,exportData,setUpdateModal,setGalleryVisible })=> {
    return (
        <Fragment>
            {item.default === false && item.status !== 'Archieved'&&
                <Colxx xxs="12">
                    <Card className="d-flex flex-row mb-3">
                        <div className="react-photo-gallery--gallery">
                            <div style={{ display: 'flex', flexFlow: 'row wrap' }}>
                                {/* <div style={{
                                margin: '2px', 'position': 'relative'
                            }}>
                                <img
                                    alt="Thumbnail"
                                    src={
                                        item.images[0]
                                            ? item.images[0].url
                                            : 'https://via.placeholder.com/250x150'
                                    }
                                    className="ml-2 my-3 list-thumbnail responsive border-0"
                                />
                            </div> */}
                            </div>
                        </div>

                        <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                            <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                                <p className="mb-1 text-center text-muted text-small w-25 w-sm-100">
                                    <b>{item.title}</b>

                                </p>
                                <p className="mb-1 text-center text-muted text-small w-20 w-sm-100">
                                    {item.subTitle}
                                </p>
                                <p className="mb-1 text-center text-muted text-small w-20 w-sm-100">
                                    {item.status}
                                </p>
                                <p className="mb-1 text-center text-muted text-small w-20 w-sm-100">
                                    {moment(item.startDate).format('YYYY-MM-DD')}
                                </p>
                                <p className="mb-1 text-center text-muted text-small w-20 w-sm-100">
                                    {moment(item.endDate).format('YYYY-MM-DD')}
                                </p>
                                <p className="mb-1 text-center text-muted text-small w-20 w-sm-100">
                                    {item.category}
                                </p>
                                <UncontrolledDropdown className="w-15 text-center w-sm-100">
                                    <DropdownToggle caret color="outline-dark" size="xs">
                                        more
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <DropdownItem onClick={() => setUpdateModal(item)}>
                                            <p>
                                                Change Status
                                            </p>
                                        </DropdownItem>
                                        <DropdownItem onClick={() => exportData(item)}>
                                            <p>
                                                Export
                                            </p>
                                        </DropdownItem>
                                        <DropdownItem onClick={() => setGalleryVisible(item)}>
                                            <p>
                                                Import
                                            </p>
                                        </DropdownItem>
                                    </DropdownMenu>

                                </UncontrolledDropdown>
                            </div>
                        </div>
                    </Card >
                </Colxx >}
        </Fragment>
    );
}

export default toDoList;